import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { yellow } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Moment from 'moment-timezone';
import React from 'react';

import { bottomBorderStyle, colorPalette, spacings, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';
import { getItemTypeSelection, getPlexRouteItemType, ItemTypeSelectionEnum } from './ItemTypeSelection';
import { eventShape, milestoneShape, postShape } from './TimelineGraphBox';
import { TimeRangeEnum } from './TimeRange';
import { TimeRangeSelect, UpdateTimelineFilters } from './TimeRangeSelect';

type Props = {
  start: Moment.Moment;
  finish: Moment.Moment;
  selectedTimeOption: TimeRangeEnum;
  updateTimelineFilters: UpdateTimelineFilters;
  itemTypeSelectionEnum: ItemTypeSelectionEnum;
};
export const TimelineHeader = ({
  start,
  finish,
  selectedTimeOption,
  updateTimelineFilters,
  itemTypeSelectionEnum,
}: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <div className={classNames(classes.headerLeft, classes.addPaddingRight)}>
        <PlexTypography className={classes.rootTitle} text={'Timeline Activity'} size={TextSizesEnum.XLarge} />
        <div className={classes.legend}>
          <Tooltip title="Post">
            <svg className={classes.svg}>{postShape(10, 10, colorPalette.purpleGray._400)}</svg>
          </Tooltip>
        </div>
        <div className={classes.legend}>
          <Tooltip title="Event">
            <svg className={classes.svg}>{eventShape(10, 10, yellow.A700)}</svg>
          </Tooltip>
        </div>
        <div className={classes.legend}>
          <Tooltip title="Milestone">
            <svg className={classes.svg}>{milestoneShape(10, 10, 'black')}</svg>
          </Tooltip>
        </div>
      </div>
      <div className={classes.headerLeft}>
        <TimeRangeSelect
          className={classes.timerange}
          start={start}
          finish={finish}
          selectedTimeOption={selectedTimeOption}
          updateTimelineFilters={updateTimelineFilters}
        />

        <FormControl className={classes.datePicker}>
          <InputLabel>Type</InputLabel>
          <Select
            value={itemTypeSelectionEnum}
            onChange={(event): void => {
              updateTimelineFilters({ itemType: getPlexRouteItemType(event.target.value as ItemTypeSelectionEnum) });
            }}
          >
            {Object.values(ItemTypeSelectionEnum)
              .filter((enumVal) => !isNaN(Number(enumVal)))
              .map((enumVal: unknown) => {
                const option = getItemTypeSelection(enumVal as ItemTypeSelectionEnum);
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.displayName}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexShrink: 0,
    height: 64,
    alignItems: 'center',
    paddingLeft: spacings.xlarge,
    paddingRight: spacings.xlarge,
    ...bottomBorderStyle,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  addPaddingRight: {
    paddingRight: 24,
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 24,
    color: colorPalette.purpleGray._500,
  },
  legendText: {
    fontWeight: 600,
  },
  rootTitle: {
    color: colorPalette.dark._900,
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  datePicker: {
    marginLeft: spacings.xlarge,
    width: 150,
  },
  svg: {
    height: 20,
    width: 20,
  },
  timerange: {
    marginLeft: spacings.xlarge,
  },
}));
